import React from "react";

import { useNavigate, useParams } from "react-router-dom";

import { ModalComunicaciones } from "components/Portfolio/Lista/Comunicaciones/Row/Comunicaciones";
import { useAppSelector } from "store/store";

export const ComentariosActivo: React.FC = () => {
	const navigate = useNavigate();
	const { assetId } = useParams();
	const iteSelected = useAppSelector((state) => state.ites.iteSelected);

	return (
		<ModalComunicaciones
			asset={iteSelected.data?.asset}
			onClose={() => navigate(`/activo/${assetId}/`)}
			type="eventos"
		/>
	);
};
